import React from 'react'

const WorkItems = ({ curElem }) => {
  const handleCardClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <a
      href={curElem.html_url}
      target="_blank"
      rel="noopener noreferrer"
      className="work__card"
      onClick={() => handleCardClick(curElem.html_url)}
    >
      <div key={curElem.id} className="card_content">
          <h2 className="repoName">{curElem.name}</h2>
          <h3 className="repoDescription">{curElem.description}</h3>
          <div className="detail-box">
            <span className="gitDetail">Language: {curElem.language}</span>
            <span className="gitDetail">
              Created On: {new Date(curElem.created_at).toLocaleDateString()}
            </span>
          </div>
      </div>
    </a>
  );
};

export default WorkItems